<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 border border-blueGray-200 rounded-lg bg-white"
  >
    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h6 class="uppercase text-blueGray-400 mb-1 text-xs">
            Overview
          </h6>
          <h2 class="text-blueGray-700 text-lg">
            <i class="pi pi-chart-pie"></i> {{ title }}
          </h2>
        </div>
      </div>
    </div>
    <div class="p-4 flex-auto">
      <div class="relative h-350-px">
        <canvas ref="canvas"></canvas>
      </div>
    </div>
  </div>
</template>
<script>
// A separate component (rather than reusing CardBarChart/CardLineChart) mainly
// because those two locate their canvas via a hardcoded `document.getElementById`,
// which only works while exactly one instance of each exists on the page — using a
// template ref here instead means this chart is safe to render more than once.
import Chart from "chart.js";

export default {
  props: ["data", "title"],
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.init(this.data);
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    init(data) {
      this.$nextTick(() => {
        const chartData = data || this.data;

        // Refresh the existing instance's data in place instead of destroying and
        // recreating it — destroy+recreate was still leaving the canvas blank after
        // a data update (e.g. the dashboard's background refresh poll), since tearing
        // down and immediately rebuilding a responsive chart on the same canvas races
        // with the browser re-measuring that canvas. Chart.js already supports
        // pushing new data into a live instance via update(); only build a fresh
        // instance the first time (or if it was destroyed).
        if (this.chart) {
          this.chart.data = chartData;
          this.chart.update();
          return;
        }

        const config = {
          type: "doughnut",
          data: chartData,
          options: {
            maintainAspectRatio: false,
            responsive: true,
            legend: {
              labels: {
                fontColor: "rgba(0,0,0,.4)",
              },
              align: "end",
              position: "bottom",
            },
            tooltips: {
              mode: "index",
              intersect: false,
            },
          },
        };
        const ctx = this.$refs.canvas.getContext("2d");
        this.chart = new Chart(ctx, config);
      });
    }
  },
  watch: {
    data(newdata) {
      this.init(newdata);
    }
  }
};
</script>
